module.exports = __webpack_public_path__ + "media/flags/ye-1f97c10b.svg";